// @ts-nocheck
import { signInResetPasswordFormStyles } from "@insite/content-library/Widgets/SignIn/SignInResetPasswordForm";
import merge from "lodash/merge";

merge(signInResetPasswordFormStyles, {
    cancelButton: {
        color: undefined,
        variant: "secondary",
    },
});
